var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:`${_vm.classVariableNameRD}-progress`},[_c('div',{class:`${_vm.colorClass}`,style:({width: `${_vm.percentage}% !important`})})])
}
var staticRenderFns = []

export { render, staticRenderFns }